import { Icon } from '@/shared/components/Icon';
import { StyledCol, StyledRow } from '@/shared/styles';
import { TopSectionProps } from '../../Pricing.consts';
import { StyledCustomTopCard, StyledTitle } from '../Package.styles';
import { StyledPackageTitle } from '@/shared/styles';
import { useTranslation } from 'react-i18next';

export const CustomTopSection: React.FC<TopSectionProps> = ({
  name,
  price,
  imageUrl,
}: TopSectionProps) => {
  const { t } = useTranslation();

  return (
    <StyledCustomTopCard>
      <StyledCol $align="center">
        <StyledTitle>{name}</StyledTitle>
        <StyledRow>
          <StyledPackageTitle>{price}</StyledPackageTitle>
        </StyledRow>
        <Icon
          $src={imageUrl}
          $height={390}
          $width={300}
          $position="absolute"
          $alt={t(`pricing.packages.${name}_package_badge.alt`)}
        />
      </StyledCol>
    </StyledCustomTopCard>
  );
};
